export default __webpack_public_path__ + "static/media/game.26b05716.png";